// import React from "react";
import { Typography, Box, Grid, Stack } from "@mui/material";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import "./mainContent.css";
import VendorCard from "../VendorCard/VendorCard";
import BlankCard from "../BlankCard/BlankCard";
import { BeatLoader } from "react-spinners";
import CustomGaugeChart from "../meter/meter";
import MapChart from "../Mapchart/Mapchart";
import BarGraph from "../Delay_In_Filing_Gstr1/BarGraph";
import { ArrowRightOutlined } from "@ant-design/icons";
import GSTR3BFilingStatusSummary from "../Gstr3B_filing_satus/GSTRBFilingStatus";
import GSTR31FilingStatusSummary from "../Gstr31_filing_status/GSTR31FilingStatusSummary";
import VendorscoreGraph from "../vendorscorehistory/vendorhistory";
import CurrentScore from "../Current_Scores/CurrentScoreTable";
import BarGraph1 from "../Delay_In_Gstr3b/BarGraph1";
import GSTTable from "../gst_table/gst_table";
import LineGraph from "../Liabilitiesgraph/liabilitiesgraph";
import React, { useEffect, useState } from "react";
import { Button} from "antd";
import BarChart1 from "../Delay_In_Gstr3b/BarGraph1";
import BarChart2 from "../Delay_In_Filing_Gstr1/BarGraph";
import ChartExample from "../Liabilitiesgraph/liabilitiesgraph";
import HSNCode from "../HSNCODE/hsncode";
import axios from "axios";
import Select from "react-select";
import VendorCard1 from "../VendorCard/Vendorcard1";
import logo1 from "../../../assets/gstin.png";
import GstModal from "../gst_table/GstModal";
import gstimg from '../../../assets/image 1133.png'
import GSTR1FilingChart from "../GSTR1FilingChart";
import GSTR3BFilingChart from "../GSTR3BFilingChart";
import UploadGSTINModal from "../BulkVerification/BulkVerification";
import InvoiceIRN from "../EinvoiceValidation/InvoiceIrn";
import VendorDetailsCard from "../VendorCardDetails/Vendordetails";
import { useMainContent } from "../../../context/MainContentContext";
import GaugeChart from "../GuageMeter/GuageChart";
import MyGauge from "../GuageMeter/GuageChart";



const MainContentVendor = () => {
  const [ids, setIds] = useState([]);
  const [gstinCount, setGstinCount] = useState("N/A");
  const [Address, setAddress] = useState("N/A");
  const [selectedPan, setSelectedPan] = useState("N/A");
  const [apiData, setApiData] = useState([]);
  const [selectedGstin, setSelectedGstin] = useState("N/A");
  const [lineGraphData1, setLineGraphData] = useState({ labels: [], data: [] });
  const [rgdt, setRgdt] = useState("N/A");
  const [aggreTurnOver, setAggreTurnOver] = useState("N/A");
  const [legalName, setLegalName] = useState()
  const [sts, setStatus] = useState();
  const [tradeName, setTradeName] = useState("N/A");
  const [hsnData, setHsnData] = useState([]);
  const [statusColor, setStatusColor] = useState("#FF3F15");
  const [einvoiceStatus, setEinvoiceStatus] = useState("N/A");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [gstin, setGstin] = useState('');


  const [prevDtls, setPrevDtls] = useState([]);
  const [gstinData, setGstinData] = useState([]);
  // const [gstinData1, setGstinData1] = useState([]);
  const [gstinDetails, setGstinDetails] = useState({});
  const [filingData, setFilingData] = useState({});
  const [Avgdelaydata, setAvgdelaydata] = useState({});

  const [filteredData, setFilteredData] = useState([]);

    // State to store GSTR1 filing dates
    const [gstr1FilingDates, setGstr1FilingDates] = useState([]);
  const [panData, setPanData] = useState([]);
  // const [PiechartData, setPiechartData] = useState([]);
  const [filteredPanData, setFilteredPanData] = useState([]);
  const [highlightGstin, setHighlightGstin] = useState(null)

  const [loading, setLoading] = useState(false); // Loader state
  const { mainContentData, setMainContentData } = useMainContent();
  const { gstinIds } = mainContentData;
  console.log(mainContentData)


  const MAX_LENGTH = 20;

const truncate = (value, maxLength = MAX_LENGTH) => {
  return value && value.length > maxLength
    ? `${value.slice(0, maxLength)}...`
    : value;
};

  
  const vendorDetails = [
    { label: 'Vendor Status', fullValue: mainContentData.status || 'N/A' },
    { label: 'GSTIN', fullValue: mainContentData.gstin || 'N/A' },
    { label: 'Trade Name', fullValue: mainContentData.tradeName || 'N/A' },
    { label: 'Legal Name', fullValue: mainContentData.legalName || 'N/A' },
    { label: 'Address', fullValue: mainContentData.address || 'N/A' },
  ].map(item => ({
    ...item,
    displayValue: truncate(item.fullValue)
  }));

  const [gstr3bFilingDates, setGstr3bFilingDates] = useState([]);



  // const handleGstinSelection = async (selectedOption) => {
  //   if (!selectedOption) {
  //     console.error('Invalid selected option:', selectedOption);
  //     return; // Exit if the input is not valid
  //   }

  //   // Extract the GSTIN ID, handling cases where selectedOption might be a string or an object
  //   const selectedGstinId = selectedOption.value || selectedOption;

  //   // Check if selectedGstinId is a string (add more validation if needed)
  //   if (typeof selectedGstinId !== 'string' || selectedGstinId.trim() === '') {
  //     console.error('Invalid GSTIN ID:', selectedGstinId);
  //     return; // Exit if the GSTIN ID is not a valid string
  //   }



  //   // Proceed with the function if the selected GSTIN ID is valid
  //   setSelectedGstin(selectedGstinId);

  //   // Continue with any additional logic you need
  //   console.log("Selected GSTIN:", selectedGstinId);

  //   // Extract PAN from the selected GSTIN (assuming PAN is part of the GSTIN)
  //   const extractedPan = selectedGstinId.slice(2, -3);
  //   setSelectedPan(extractedPan); // Set the selected PAN in the PAN dropdown

  //   if (selectedGstinId) {
  //     try {
  //       // Fetch data from the first API endpoint
  //       const response1 = await axios.get(
  //         `https://vendor-score.finkraftai.com/api/gstins/${selectedGstinId}`
  //       );
  //       const data1 = response1.data;

  //       // Fetch data from the second API endpoint
  //       const response2 = await fetch(
  //         "https://vendor-score.finkraftai.com/gstin-data",
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ id: selectedGstinId }),
  //         }
  //       );

  //       if (!response2.ok) {
  //         throw new Error("Failed to fetch GSTIN data from second API");
  //       }

  //       const data2 = await response2.json();
  //       console.log(data2);

  //       const response3 = await fetch(
  //         "https://vendor-score.finkraftai.com/get_gstin",
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ pan_number: extractedPan }),
  //         }
  //       );
  //       const data = await response3.json();
  //       const gstinIds = data.gstin_ids;
  //       setGstinCount(gstinIds.length);
  //       setGstinData1(gstinIds);

  //       // Combine and process the data
  //       setGstinDetails({
  //         total_weightage: data1.total_weightage,
  //         gstr1_current_weightage: data1.gstr1_current_weightage,
  //         gstr1_previous_weightage: data1.gstr1_previous_weightage,
  //         gstr3b_recent_weightage: data1.gstr3b_recent_weightage,
  //         gstr3b_previous_weightage: data1.gstr3b_previous_weightage,
  //         liability_payment_score: data1.liability_payment_score,
  //       });

  //       setFilingData(data1.filing_data);
  //       console.log("filing:", data1.filing_data);
  //       console.log("Avg_data:", data1.Avg_data);

  //       setAvgdelaydata(data1.Avg_data);

  //       if (data2.liabilityhistory && data2.liabilityhistory.prevdtls) {
  //         setPrevDtls(data2.liabilityhistory.prevdtls);
  //       } else {
  //         setLineGraphData({ labels: [], data: [] }); // Reset data if not found
  //       }
        

  //       const { info } = data2;
  //       if (info) {
  //         setRgdt(info.rgdt || "Not Available");
  //         setAggreTurnOver(info.aggreTurnOver || "Not Available");
  //         setLegalName(info.lgnm || "Not Available");
  //         setTradeName(info.tradeNam || "Not Available");
  //         setStatus(info.sts || "Not Available");
  //         if (info.einvoiceStatus === "Yes") {
  //           setEinvoiceStatus("Eligible");
  //           setStatusColor("#00A859"); // Green color for eligible
  //         } else if (info.einvoiceStatus === "No") {
  //           setEinvoiceStatus("Not Eligible");
  //           setStatusColor("#FF3F15"); // Red color for not eligible
  //         } else {
  //           setEinvoiceStatus("Not Available");
  //           setStatusColor("#B0B0B0"); // Gray color for not available
  //         }
  //       } else {
  //         setEinvoiceStatus("Not Available");
  //         setStatusColor("#B0B0B0");
  //       }

  //       const { pob } = data2;
  //       if (pob) {
  //         const address = pob?.pradr?.adr || "Not Available";
  //         setAddress(address);
  //       }

  //       const { HSN } = data2;
  //       const filingHistory = data2.filinghistory;

  //       if (filingHistory && filingHistory["2024"]) {
  //         const filingStatus = filingHistory["2024"].filingStatus;
        
  //         if (Array.isArray(filingStatus)) {
  //           // Extract GSTR1 and GSTR3B data
  //           const gstr1FilingDates = [];
  //           const gstr3bFilingDates = [];
        
  //           filingStatus.forEach((filingArray) => {
  //             if (Array.isArray(filingArray)) {
  //               filingArray.forEach((filing) => {
  //                 const { rtntype, dof, taxp } = filing;
        
  //                 if (rtntype === "GSTR1") {
  //                   gstr1FilingDates.push({ month: taxp, dateOfFiling: dof });
  //                 } else if (rtntype === "GSTR3B") {
  //                   gstr3bFilingDates.push({ month: taxp, dateOfFiling: dof });
  //                 }
  //               });
  //             }
  //           });
        
  //           // Save to state
  //           setGstr1FilingDates(gstr1FilingDates);
  //           setGstr3bFilingDates(gstr3bFilingDates);
        
  //           console.log("GSTR1 Filing Dates:", gstr1FilingDates);
  //           console.log("GSTR3B Filing Dates:", gstr3bFilingDates);
  //         } else {
  //           console.log("No valid filing data found for 2024-2025");
  //         }
  //       } else {
  //         console.log("No filing history found for 2024-2025");
  //       }

  //       console.log("HSN data:", HSN); // Debugging log to see HSN data

  //       if (HSN && (HSN.bzgddtls || HSN.bzsdtls)) {
  //         const details = HSN.bzgddtls || HSN.bzsdtls; // Use the available key
  //         const extractedData = details.map((item) => ({
  //           gdes: item.gdes || item.sdes,
  //           hsncd: item.hsncd || item.saccd
  //         }));
  //         console.log("hsn data added", extractedData);

  //         setHsnData(extractedData);
  //       } else {
  //         console.log("No hsn data");
  //       }


  //     } catch (error) {
  //       console.error("Error fetching GSTIN data:", error);
  //       setGstinDetails({});
  //       setFilingData({});
  //       setLineGraphData({ labels: [], data: [] });
  //       setRgdt("Not Available");
  //       setAggreTurnOver("Not Available");
  //       setEinvoiceStatus("Not Available");
  //       setStatusColor("#B0B0B0");
  //       setAddress("Not Available");
  //     }
  //   } else {
  //     setGstinDetails({});
  //     setFilingData({});
  //     setLineGraphData({ labels: [], data: [] });
  //     setRgdt("Not Available");
  //     setAggreTurnOver("Not Available");
  //     setEinvoiceStatus("Not Available");
  //     setStatusColor("#B0B0B0");
  //     setAddress("Not Available");
  //   }
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true); // Ensure loading starts before try block
  //     console.log("Loader activated (should be true):", true);

  //     try {
  //       // Simulating a network request delay (REMOVE this in production)
  //       await new Promise((resolve) => setTimeout(resolve, 2000));

  //       if (gstin) {
  //         console.log("Selected GSTIN:", gstin);
  //         handleGstinSelection(gstin);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //       console.log("Loader deactivated (should be false):", false);
  //     }
  //   };

  //   fetchData();
  // }, [gstin]);


  const handleGstinSelection = async (selectedOption) => {
    if (!selectedOption) {
      console.error("Invalid selected option:", selectedOption);
      return; // Exit if the input is not valid
    }
  
    // Extract the GSTIN ID, handling cases where selectedOption might be a string or an object
    const selectedGstinId = selectedOption.value || selectedOption;
  
    // Check if selectedGstinId is a string (add more validation if needed)
    if (typeof selectedGstinId !== "string" || selectedGstinId.trim() === "") {
      console.error("Invalid GSTIN ID:", selectedGstinId);
      return; // Exit if the GSTIN ID is not a valid string
    }
  
    // Proceed with the function if the selected GSTIN ID is valid
    setSelectedGstin(selectedGstinId);
  
    // Extract PAN from the selected GSTIN (assuming PAN is part of the GSTIN)
    const extractedPan = selectedGstinId.slice(2, -3);
    setSelectedPan(extractedPan); // Set the selected PAN in the PAN dropdown
  
    if (selectedGstinId) {
      try {
        setLoading(true); // Start loading
  
        // Fetch data from the first API endpoint
        const response1 = await axios.get(
          `https://vendor-score.finkraftai.com/api/gstins/${selectedGstinId}`
        );
        const data1 = response1.data;
  
        // Fetch data from the second API endpoint
        const response2 = await fetch(
          "https://vendor-score.finkraftai.com/gstin-data",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: selectedGstinId }),
          }
        );
  
        if (!response2.ok) {
          throw new Error("Failed to fetch GSTIN data from second API");
        }
  
        const data2 = await response2.json();
  
        // Fetch data from the third API endpoint
        const response3 = await fetch(
          "https://vendor-score.finkraftai.com/get_gstin",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ pan_number: extractedPan }),
          }
        );
        const data3 = await response3.json();
        const gstinIds = data3.gstin_ids;
  
        // Combine and process the data
        const gstinDetails = {
          total_weightage: data1.total_weightage,
          gstr1_current_weightage: data1.gstr1_current_weightage,
          gstr1_previous_weightage: data1.gstr1_previous_weightage,
          gstr3b_recent_weightage: data1.gstr3b_recent_weightage,
          gstr3b_previous_weightage: data1.gstr3b_previous_weightage,
          liability_payment_score: data1.liability_payment_score,
        };
  
        const filingData = data1.filing_data;
        const avgDelayData = data1.Avg_data;
  
        const prevDtls =
          data2.liabilityhistory && data2.liabilityhistory.prevdtls
            ? data2.liabilityhistory.prevdtls
            : [];
  
        const { info } = data2;
        const rgdt = info?.rgdt || "Not Available";
        const aggreTurnOver = info?.aggreTurnOver || "Not Available";
        const legalName = info?.lgnm || "Not Available";
        const tradeName = info?.tradeNam || "Not Available";
        const status = info?.sts || "Not Available";
        const einvoiceStatus =
          info?.einvoiceStatus === "Yes"
            ? "Eligible"
            : info?.einvoiceStatus === "No"
            ? "Not Eligible"
            : "Not Available";
        const statusColor =
          info?.einvoiceStatus === "Yes"
            ? "#00A859"
            : info?.einvoiceStatus === "No"
            ? "#FF3F15"
            : "#B0B0B0";
  
        const address = data2.pob?.pradr?.adr || "Not Available";
  
        const { HSN } = data2;
        const hsnData =
          HSN && (HSN.bzgddtls || HSN.bzsdtls)
            ? (HSN.bzgddtls || HSN.bzsdtls).map((item) => ({
                gdes: item.gdes || item.sdes,
                hsncd: item.hsncd || item.saccd,
              }))
            : [];
  
        const filingHistory = data2.filinghistory;
        const gstr1FilingDates = [];
        const gstr3bFilingDates = [];
  
        if (filingHistory && filingHistory["2024"]) {
          const filingStatus = filingHistory["2024"].filingStatus;
  
          if (Array.isArray(filingStatus)) {
            filingStatus.forEach((filingArray) => {
              if (Array.isArray(filingArray)) {
                filingArray.forEach((filing) => {
                  const { rtntype, dof, taxp } = filing;
  
                  if (rtntype === "GSTR1") {
                    gstr1FilingDates.push({ month: taxp, dateOfFiling: dof });
                  } else if (rtntype === "GSTR3B") {
                    gstr3bFilingDates.push({ month: taxp, dateOfFiling: dof });
                  }
                });
              }
            });
          }
        }
  
        // Save all data to the context
        setMainContentData({
          gstin,
          gstinDetails,
          filingData,
          avgDelayData,
          prevDtls,
          rgdt,
          aggreTurnOver,
          legalName,
          tradeName,
          status,
          einvoiceStatus,
          statusColor,
          address,
          hsnData,
          gstr1FilingDates,
          gstr3bFilingDates,
          gstinIds,
          gstinCount: gstinIds.length,
        });
  
        console.log("Data saved to context:", {
          gstin,
          gstinDetails,
          filingData,
          avgDelayData,
          prevDtls,
          rgdt,
          aggreTurnOver,
          legalName,
          tradeName,
          status,
          einvoiceStatus,
          statusColor,
          address,
          hsnData,
          gstr1FilingDates,
          gstr3bFilingDates,
          gstinIds,
          gstinCount: gstinIds.length,
        });
      } catch (error) {
        console.error("Error fetching GSTIN data:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    }
  };

  const options = filteredData.map((gstin) => ({
    value: gstin,
    label: gstin,
  }));


  // const handleInputChange = (inputValue) => {
  
  //   if (inputValue) {
  //     const filtered = gstinData.filter((gstin) =>
  //       gstin.toLowerCase().includes(inputValue.toLowerCase())
  //     );
  //     setFilteredData(filtered);
  //   } else {
  //     if (selectedPan) {
  //       setFilteredData(gstinData1)
  //     }
  //     else {
  //       setFilteredData(gstinData.slice(0, 5000));
  //     }
  //   }
  // };

  const handleInputChange1 = (e) => {
    setGstin(e.target.value);
    setGstinError('');
  };
  

  const handlePanInputChange = (inputValue) => {
    if (inputValue) {
      const filtered = panData.filter((pan) =>
        pan.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredPanData(filtered);
    } else {

      setFilteredPanData(panData.slice(0, 5000));
    }
  };



  const options1 = filteredPanData.map((pan) => ({
    value: pan,
    label: pan,
  }));

  const panoptions = panData.map((pan) => ({
    value: pan,
    label: pan,
  }));

  // const handlePanSelection = async (selectedOption) => {
  //   const pan = selectedOption.value;
  //   console.log("pan:", pan);

  //   setSelectedPan(pan);
  //   try {
  //     const response = await fetch(
  //       "https://vendor-score.finkraftai.com/get_gstin",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ pan_number: pan }),
  //       }
  //     );
  //     const data = await response.json();
  //     // Get the GSTINs
  //     const gstinIds = data.gstin_ids;
  //     // Update the GSTIN count
  //     setGstinCount(gstinIds.length);
  //     // Store the GSTINs in state
  //     setFilteredData(gstinIds);
  //     setGstinData1(gstinIds)
  //     if (gstinIds.length > 0) {
  //       handleGstinSelection(gstinIds[0]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching GSTIN count:", error);
  //     setGstinCount(0); // Reset count in case of error
  //   }
  // };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#ebf5f6',  // Light teal color like the background
      borderColor: '#d6e8e8',  // Border color similar to the image
      borderRadius: '20px',  // Rounded edges
      minHeight: '30px',
      boxShadow: state.isFocused ? '0 0 0 2px #77c9c9' : null,  // Add border shadow on focus
      '&:hover': {
        borderColor: '#77c9c9',  // Change border color on hover
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 10px',  // Adjust padding for text alignment
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#007c7c',  // Teal placeholder color
      fontSize: '16px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#0A8394',  // Teal text for the selected value
      fontSize: '16px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#0A8394',  // Teal color for dropdown arrow
    }),
    indicatorSeparator: () => ({
      display: 'none',  // Remove separator between input and dropdown arrow
    }),
  };

  const onBtnClicked = () => {
    if (selectedGstin) {
      setIsModalVisible(true);
    }
    else {
      alert('Please N/A')
    }
  };

  const handleGstinSelect = (gstin) => {
    console.log('Selected GSTIN:', gstin);
    setHighlightGstin(gstin);
    // You can now use the selected GSTIN as needed
  };


  

  

  const fetchData = async (selectedGstin) => {
    setLoading(true);
    console.log("Loader activated (should be true):", true);
  
    try {
      // Simulating a network request delay (REMOVE this in production)
      await new Promise((resolve) => setTimeout(resolve, 2000));
  
      if (selectedGstin) {
        console.log("Selected GSTIN:", selectedGstin);
        handleGstinSelection(selectedGstin);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      console.log("Loader deactivated (should be false):", false);
    }
  };
  const [gstinError, setGstinError] = useState('');

  const handleSearchgstin = () => {
    const gstinTrimmed = gstin.trim();

    const isValidGSTIN = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstinTrimmed);

    if (!gstinTrimmed) {
      setGstinError('Please enter a GSTIN.');
    } else if (!isValidGSTIN) {
      setGstinError('Invalid GSTIN format. It must be 15 characters like: 27ABCDE1234F1Z5');
      setMainContentData({
      gstin: "",
      gstinData: [],
      gstinDetails: {},
      filingData: {},
      Avgdelaydata: {},
      gstr1FilingDates: [],
      gstr3bFilingDates: [],
      hsnData: [],
      prevDtls: [],
      rgdt: "N/A",
      aggreTurnOver: "N/A",
      legalName: "N/A",
      tradeName: "N/A",
      einvoiceStatus: "N/A",
      statusColor: "#B0B0B0",
      gstinCount: "N/A",
    });
    } else {
      setGstinError('');
      fetchData(gstinTrimmed);
    }
  };

  const [isBulkVerifyModalOpen, setIsBulkVerifyModalOpen] = useState(false);

  const handleOpenModal = () => {
    console.log("Open modal");
    setIsBulkVerifyModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsBulkVerifyModalOpen(false);
  };


  const [showTooltip, setShowTooltip] = useState(false);
  console.log("Avgdelaydata:", mainContentData.avgDelayData);

  return (
    <div className="mainsection-vendor">
       {loading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
            padding: ' 500px 400px'
          }}>
            <BeatLoader color="#36D7B7" size={20} />
          </div>
        )}
        <UploadGSTINModal open={isBulkVerifyModalOpen} onClose={handleCloseModal} />
      <div className="vendor-navbar">
      <div className="vendor-navbar-right">
          <InvoiceIRN/>
          </div>
  
        <div className="vendorContainer-card">
         <div className="card">
         <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
           <header className="vendorcontainer-header">Check your vendor compliance</header>
           <div className="tooltip-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.521 8.904 12.713 8.712C12.905 8.52 13.0007 8.28267 13 8C12.9993 7.71733 12.9033 7.48 12.712 7.288C12.5207 7.096 12.2833 7 12 7C11.7167 7 11.4793 7.096 11.288 7.288C11.0967 7.48 11.0007 7.71733 11 8C10.9993 8.28267 11.0953 8.52033 11.288 8.713C11.4807 8.90567 11.718 9.00133 12 9ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12C21.998 13.3827 21.7353 14.6827 21.212 15.9C20.6887 17.1173 19.9763 18.1757 19.075 19.075C18.1737 19.9743 17.1153 20.687 15.9 21.213C14.6847 21.739 13.3847 22.0013 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#999999"/>
</svg>
        <div className="tooltip-text">
        Enter the vendor's GSTIN and click "Verify" to view vendor score and detailed information for that specific GSTIN.
        </div>
      </div>
           </div>
         

            <label className="vendorRequired" >Vendor GSTIN<span className="required">*</span></label>
            <input className="vendorcontainer-input" type="text" style={{width:'95%'}} placeholder="Enter GSTIN" value={gstin}  onChange={handleInputChange1} />
            {gstinError && (
                <div style={{ color: 'red' , fontSize:'12px' }}>{gstinError}</div>
              )}
            <div className="btns">

            <button className="vendorcheck-btn"  onClick={handleSearchgstin}>Verify</button>
            </div>
          </div>
          </div>



        
      </div>
      <div className="Topdiv">
        <div className="cards-row">
          <div className="smallcard1">
            <div className="img-div">
              <img src={logo1} className="vendor-img" />
            </div>
            <p className="c-des">No. of GSTINs</p>
            <h4 className="c-head">{mainContentData.gstinCount}</h4>
          </div>
          <div className="smallcard1">
            <div className="img-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                className="vendor-img"
              >
                <path
                  d="M13 5.66667V3.66667C13 2.93029 12.3284 2.33333 11.5 2.33333H2.5C1.67157 2.33333 1 2.93029 1 3.66667V5.66667M13 5.66667V11.6667C13 12.4031 12.3284 13 11.5 13H2.5C1.67157 13 1 12.4031 1 11.6667V5.66667M13 5.66667H1M4 1V3.66667M10 1V3.66667"
                  stroke="#0A8394"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            <p className="c-des">Date of Registration</p>
            <h4 className="c-head">{mainContentData.rgdt}</h4>
          </div>
          <div className="smallcard1">
            <div className="img-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="vendor-img"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5 1.56C8.66575 1.56 8.82475 1.62585 8.94194 1.74305L13.3169 6.11806C13.561 6.36212 13.561 6.75787 13.3169 7.00194C13.0729 7.246 12.6771 7.246 12.4331 7.00194L9.125 3.69388V12.185C9.125 12.5302 8.84519 12.81 8.5 12.81C8.15481 12.81 7.875 12.5302 7.875 12.185V3.69388L4.56694 7.00194C4.32286 7.246 3.92714 7.246 3.68306 7.00194C3.43898 6.75787 3.43898 6.36212 3.68306 6.11806L8.05806 1.74305C8.17525 1.62585 8.33425 1.56 8.5 1.56Z"
                  fill="#0A8394"
                />
              </svg>
            </div>
            <p className="c-des">E Annual Aggregate Turnover</p>
            <h4 className="c-head">{mainContentData.aggreTurnOver}</h4>
          </div>
          <div className="smallcard1">
            <div className="img-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="vendor-img"
              >
                <g clip-path="url(#clip0_1099_4749)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.59551 1.06345C4.94338 0.889529 5.3584 0.684998 6.125 0.684998C6.89156 0.684998 7.30662 0.88951 7.6545 1.06344L7.66444 1.06842C7.93669 1.20457 8.14744 1.30994 8.625 1.30995C9.39819 1.30999 9.85612 1.02169 10.0088 0.906948C10.2465 0.728323 10.5273 0.743385 10.7212 0.83306C10.9176 0.923891 11.125 1.14062 11.125 1.46092V8.185H13C14.0351 8.185 14.875 9.02343 14.875 10.0594V11.935C14.875 12.5131 14.7287 12.9882 14.4771 13.3657C14.2281 13.7392 13.9005 13.9804 13.592 14.1346C13.2859 14.2877 12.9874 14.3611 12.7707 14.3972C12.6406 14.4189 12.5072 14.4352 12.375 14.435h4.625C3.04689 14.435 2.57175 14.2887 2.19433 14.0371C1.82082 13.7881 1.57962 13.4605 1.42536 13.152C1.27232 12.8459 1.19892 12.5474 1.1628 12.3307C1.14449 12.2209 1.1351 12.128 1.13025 12.0601C1.12621 12.0036 1.12502 11.9701 1.125 11.935V1.46091C1.125 1.14062 1.3324 0.923891 1.52879 0.83306C1.72267 0.743379 2.00351 0.728316 2.24118 0.906929C2.39387 1.02167 2.85181 1.30995 3.625 1.30995C4.10259 1.30995 4.3133 1.20459 4.58555 1.06844L4.59551 1.06345ZM2.37707 11.935L2.375 2.36232C2.71261 2.4761 3.12958 2.55995 3.625 2.55995C4.3916 2.55995 4.80662 2.35543 5.15449 2.1815L5.16445 2.17652C5.4367 2.04037 5.64741 1.935 6.125 1.935C6.60261 1.935 6.81331 2.04037 7.08556 2.17652L7.0955 2.18149C7.44338 2.35541 7.85838 2.55993 8.625 2.55995C9.12044 2.55997 9.53738 2.47613 9.875 2.36233V11.935C9.875 12.4244 9.97987 12.84 10.1647 13.185h4.625C3.26561 13.185 3.03762 13.0969 2.88771 12.997C2.73387 12.8944 2.62351 12.7532 2.54339 12.593C2.46205 12.4303 2.41827 12.2601 2.39579 12.1252C2.38523 12.0618 2.37882 11.999 2.37707 11.935ZM12.5652 13.1642C12.7001 13.1417 12.8703 13.0979 13.033 13.0166C13.1932 12.9365 13.3344 12.8261 13.437 12.6723C13.5369 12.5224 13.625 12.2944 13.625 11.935V10.0594C13.625 9.71462 13.3456 9.435 13 9.435H11.125V11.935C11.125 12.2944 11.2131 12.5224 11.313 12.6723C11.4156 12.8261 11.5568 12.9365 11.717 13.0166C11.8797 13.0979 12.0499 13.1417 12.1848 13.1642C12.2507 13.1752 12.3043 13.1804 12.3389 13.1829C12.4143 13.1883 12.4911 13.1766 12.5652 13.1642Z"
                    fill="#0A8394"
                  />
                  <path
                    d="M3.625 5.06C3.625 4.71482 3.90483 4.435 4.25 4.435H8C8.34519 4.435 8.625 4.71482 8.625 5.06C8.625 5.40518 8.34519 5.685 8 5.685H4.25C3.90483 5.685 3.625 5.40518 3.625 5.06Z"
                    fill="#0A8394"
                  />
                  <path
                    d="M3.625 7.56C3.625 7.21481 3.90483 6.935 4.25 6.935H8C8.34519 6.935 8.625 7.21481 8.625 7.56C8.625 7.90519 8.34519 8.185 8 8.185H4.25C3.90483 8.185 3.625 7.90519 3.625 7.56Z"
                    fill="#0A8394"
                  />
                  <path
                    d="M3.625 10.06C3.625 9.71481 3.90483 9.435 4.25 9.435H8C8.34519 9.435 8.625 9.71481 8.625 10.06C8.625 10.4052 8.34519 10.685 8 10.685H4.25C3.90483 10.685 3.625 10.4052 3.625 10.06Z"
                    fill="#0A8394"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1099_4749">
                    <rect
                      width="15"
                      height="15"
                      fill="white"
                      transform="translate(0.5 0.0599976)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p className="c-des">E-Invoicing</p>
            <h4 className="c-head" style={{ color: statusColor }}>{mainContentData.einvoiceStatus}</h4>
          </div>
          
          <div className="smallcard2">
            <div className="img-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                className="vendor-img"
              >
                <g clip-path="url(#clip0_1099_4755)">
                  <path
                    d="M14.667 0.726685H6.66699C6.49018 0.726685 6.32061 0.796922 6.19559 0.921947C6.07056 1.04697 6.00033 1.21654 6.00033 1.39335V3.39335H1.33366C1.15685 3.39335 0.987279 3.46359 0.862254 3.58861C0.73723 3.71364 0.666992 3.88321 0.666992 4.06002V14.7267C0.666992 14.9035 0.73723 15.0731 0.862254 15.1981C0.987279 15.3231 1.15685 15.3934 1.33366 15.3934H14.667C14.8438 15.3934 15.0134 15.3231 15.1384 15.1981C15.2634 15.0731 15.3337 14.9035 15.3337 14.7267V1.39335C15.3337 1.21654 15.2634 1.04697 15.1384 0.921947C15.0134 0.796922 14.8438 0.726685 14.667 0.726685ZM8.66699 14.06H2.00033V4.72668H8.66699V14.06ZM14.0003 14.06H10.0003V4.06002C10.0003 3.88321 9.93009 3.71364 9.80506 3.58861C9.68004 3.46359 9.51047 3.39335 9.33366 3.39335H7.33366V2.06002H14.0003V14.06ZM3.33366 6.72668C3.33366 6.54987 3.4039 6.3803 3.52892 6.25528C3.65395 6.13026 3.82351 6.06002 4.00033 6.06002H6.66699C6.8438 6.06002 7.01337 6.13026 7.1384 6.25528C7.26342 6.3803 7.33366 6.54987 7.33366 6.72668C7.33366 6.9035 7.26342 7.07306 7.1384 7.19809C7.01337 7.32311 6.8438 7.39335 6.66699 7.39335H4.00033C3.82351 7.39335 3.65395 7.32311 3.52892 7.19809C3.4039 7.07306 3.33366 6.9035 3.33366 6.72668ZM3.33366 9.39335C3.33366 9.21654 3.4039 9.04697 3.52892 8.92195C3.65395 8.79692 3.82351 8.72668 4.00033 8.72668H6.66699C6.8438 8.72668 7.01337 8.79692 7.1384 8.92195C7.26342 9.04697 7.33366 9.21654 7.33366 9.39335C7.33366 9.57016 7.26342 9.73973 7.1384 9.86476C7.01337 9.98978 6.8438 10.06 6.66699 10.06H4.00033C3.82351 10.06 3.65395 9.98978 3.52892 9.86476C3.4039 9.73973 3.33366 9.57016 3.33366 9.39335ZM3.33366 12.06C3.33366 11.8832 3.4039 11.7136 3.52892 11.5886C3.65395 11.4636 3.82351 11.3934 4.00033 11.3934H6.66699C6.8438 11.3934 7.01337 11.4636 7.1384 11.5886C7.26342 11.7136 7.33366 11.8832 7.33366 12.06C7.33366 12.2368 7.26342 12.4064 7.1384 12.5314C7.01337 12.6564 6.8438 12.7267 6.66699 12.7267H4.00033C3.82351 12.7267 3.65395 12.6564 3.52892 12.5314C3.4039 12.4064 3.33366 12.2368 3.33366 12.06Z"
                    fill="#0A8394"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1099_4755">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 0.0599976)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p className="c-des"> Trade Name</p>
            <h4 className="c-head">{mainContentData.tradeName}</h4>
          </div>
        </div>

      </div>
      <div2 className="div2">
      <div className="map-chart">
  <MapChart gstinData={gstinIds || []} highlightGstin={highlightGstin} />
  <GSTTable gstinData={gstinIds || []} onGstinSelect={handleGstinSelect} />
</div>
        <div className="vendor-card">
      <h3 className="card-title">Vendor Details</h3>
      <hr className="divider" />
      {vendorDetails.map((item, index) => {
  const isNA = item.fullValue === 'N/A';
  const isVendorStatus = item.label === 'Vendor Status';

  return (
    <div key={index} className="vendor-row bordered">
      <span className="vendor-label">{item.label}</span>
      <span
        className={`vendor-value ${isNA ? 'na' : 'has-value'} ${
          isVendorStatus && !isNA ? 'vendor-status' : ''
        }`}
        title={item.fullValue.length > MAX_LENGTH ? item.fullValue : undefined}
      >
        {isVendorStatus && !isNA && <span className="green-dot" />}
        {item.displayValue}
      </span>
    </div>
  );
})}

    </div>
        <div className="rightContainer">
          {/* <BlankCard
            component={MyGauge}
            totalWeightage={mainContentData.gstinDetails.total_weightage}
          /> */}
          <MyGauge totalWeightage={mainContentData.gstinDetails.total_weightage}/>
        </div>
        {/* <div className="addcred-card">
          <img src={gstimg} className="gstimg" />
          <h3 className="mainheader1">Add your credentials here to know
            <br></br> about your GST.</h3>
          <button onClick={onBtnClicked} className="addcred-btn1" >+ Add Credentials</button>
          <GstModal
            visible={isModalVisible}
            onClose={() => setIsModalVisible(false)}
            gstin={selectedGstin} // Pass selected GSTIN to modal
          />
        </div> */}
    
    
        <div>

        </div>
      </div2>
      <div className="div3">
        <div className="barchart">
          {/* <BarChart2 filingData={filingData} /> */}
          <GSTR1FilingChart filingData={mainContentData.filingData} />
        </div>
        <div className="right-gstr1">
          <GSTR31FilingStatusSummary Avgdelaydata={mainContentData.avgDelayData} gstr1FilingDates={mainContentData.gstr1FilingDates}/>
        </div>
      </div>
      <div className="div4">
        <div className="barchart">
          {/* <BarChart1 filingData={filingData} /> */}
          <GSTR3BFilingChart filingData={mainContentData.filingData} />
        </div>
        <div className="right-gstr3b">
          <GSTR3BFilingStatusSummary Avgdelaydata={mainContentData.avgDelayData} gstr3bFilingDates={mainContentData.gstr3bFilingDates}/>
        </div>
      </div>
      <div className="div5">
        <div className="hsndiv">
          <HSNCode hsnData={mainContentData.hsnData} />
        </div>
        <div className="liachart">
          <ChartExample prevDtls={mainContentData.prevDtls} />
        </div>
      </div>
    </div>
  );
};

export default MainContentVendor;
